import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyHelpInlineComponent } from './help-inline.component';
import { SkyResourcesModule } from '../resources';


export class SkyHelpInlineModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        SkyHelpInlineComponent
    ],
    imports: [
        CommonModule,
        SkyResourcesModule
    ],
    exports: [
        SkyHelpInlineComponent
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
